<template>

</template>

<script>
import httpRequest from '@/module_visitor/api/http.js';
export default {
    created() {
        this.getCode();
    },
    methods: {
        getUrlCode() {
            // 截取url中的code方法
            var url = location.search;
            var theRequest = new Object();
            if (url.indexOf('?') != -1) {
                var str = url.substr(1);
                var strs = str.split('&');
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
                }
            }
            return theRequest;
        },

        getCode() {
            var lcoal_openid = localStorage.getItem('v_openid');
            if (lcoal_openid) {
                return;
            }
            // 非静默授权，第一次有弹框
            var wxcode = '';
            var local = window.location.href; // 获取页面url
            var appid = 'wx1ce3f05b6999b325';
            let scope = 'snsapi_base';
            var wxcode = this.getUrlCode().code; // 截取code
            if (wxcode == null || wxcode === '') {
                // 如果没有code，则去请求
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
                    local,
                )}&response_type=code&scope=${scope}&state=123#wechat_redirect`;
                localStorage.setItem('auth', true);
            } else {
                // 你自己的业务逻辑
                httpRequest.get(`/wechat/getOpenid`, { code: wxcode }).then(res => {
                    var { code, data } = res.data;
                    if (code == 200) {
                        localStorage.setItem('v_openid', data);
                        this.$router.go(-2);
                    }
                });
            }
        },
    },
};
</script>

<style>
</style>